import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./App.css";

import { FiMenu, FiUsers, FiLogOut } from "react-icons/fi";

import logoFull from "./assets/logo.png";
import logoMark from "./assets/logo.png";

const SharedLayout = ({ children, pageTitle }) => {
  const { userId } = useParams();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const [activeMenu, setActiveMenu] = useState("FİRMALAR");
  const location = useLocation();
  const navigate = useNavigate();

  const toggleSidebar = () => setSidebarCollapsed((s) => !s);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) setSidebarCollapsed(true);
    };
    handleResize(); // ilk yüklemede
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith(`/${userId}/companies`)) {
      setActiveMenu("FİRMALAR");
    }
  }, [location.pathname, userId]);

  const handleMenuClick = (menuName) => {
    setActiveMenu(menuName);
    if (menuName === "FİRMALAR") navigate(`/${userId}/companies`);
    else if (menuName === "ÇIKIŞ YAP") handleLogout();
  };

  const menuItems = [
    { name: "FİRMALAR", icon: <FiUsers className="mr-3" /> },
    { name: "ÇIKIŞ YAP", icon: <FiLogOut className="mr-3" /> },
  ];

  const itemWrapper =
    "flex items-center p-3 w-full text-left rounded-lg transition-colors";
  const textBaseInactive = "font-medium text-white/70 hover:text-white";
  const textActive = "font-extrabold text-white";
  const iconClass = (isActive, isLogout) =>
    `${
      isLogout ? "text-red-400" : isActive ? "text-white" : "text-white/70"
    } mr-3`;

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("superadmin_token");
      if (token) {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}/superadmin/logout`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch (err) {
      console.warn("Logout request failed:", err.message);
    }

    localStorage.removeItem("superadmin_token");
    localStorage.removeItem("superadmin_user");
    sessionStorage.clear();

    window.location.href = "/";
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`bg-gradient-to-b from-[#07183c] to-[#030b1f] text-white shadow-md transition-all duration-300 flex flex-col rounded-xl
                    ${sidebarCollapsed ? "w-20" : "w-64"} m-2 sm:m-5`}
      >
        {/* Logo */}
        <div
          className={`flex items-start justify-start ${
            sidebarCollapsed ? "p-4 h-12" : "pt-8 pr-4 pl-8 h-28"
          }`}
        >
          <img
            src={logoFull}
            alt="ZENOLearn"
            className={`h-20 object-contain ${
              sidebarCollapsed ? "hidden" : "block"
            }`}
            loading="eager"
            decoding="async"
          />
          <img
            src={logoMark}
            alt="ZENO"
            className={`h-8 w-8 object-contain ${
              sidebarCollapsed ? "block" : "hidden"
            }`}
            loading="eager"
            decoding="async"
          />
        </div>

        {/* Menu */}
        <div className="flex-1 overflow-y-auto">
          <nav className="mt-4">
            <div className="px-4">
              <ul>
                {menuItems.map((item) => {
                  const isActive = activeMenu === item.name;
                  return (
                    <li key={item.name} className="mb-1">
                      <button
                        onClick={() => handleMenuClick(item.name)}
                        className={`group ${itemWrapper} ${
                          item.name === "ÇIKIŞ YAP" ? "hover:bg-red-600/20" : ""
                        }`}
                      >
                        {!sidebarCollapsed &&
                          React.cloneElement(item.icon, {
                            className: iconClass(
                              isActive,
                              item.name === "ÇIKIŞ YAP"
                            ),
                          })}
                        {!sidebarCollapsed && (
                          <span
                            className={`${
                              isActive ? textActive : textBaseInactive
                            }`}
                          >
                            {item.name}
                          </span>
                        )}
                        {sidebarCollapsed &&
                          React.cloneElement(item.icon, {
                            className: iconClass(isActive).replace(" mr-3", ""),
                          })}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          </nav>
        </div>
      </div>

      {/* Main */}
      <div className="flex-1 overflow-auto">
        <div className="p-4 sm:p-6">
          <div className="flex items-center mb-8">
            <button
              onClick={toggleSidebar}
              className="mr-4 text-gray-600 hover:text-gray-900"
              aria-label={
                sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"
              }
              title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              <FiMenu className="text-2xl" />
            </button>
            <h1 className="text-2xl font-bold main-header-font">{pageTitle}</h1>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default SharedLayout;
